import controller from './vd-switch.controller'
import template from './vd-switch.html'

const SwitchComponent = {
  bindings: {
    disabled: '<',
  },
  require: {
    ngModelCtrl: 'ngModel',
  },
  template,
  controller,
}

export default SwitchComponent
